var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 38,
    viewBox: "0 0 51 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1443 3.40175C13.051 5.65965 7.7836 10.3787 6.47373 18.5913C6.11713 20.8252 6.61518 19.138 8.12228 18.0045C13.043 14.3028 22.7181 15.6135 24.0609 24.0673C26.7623 39.0356 8.14419 41.6269 2.63377 33.3603C1.35179 31.4388 0.503114 29.1959 0.197312 26.7328C-1.13049 16.02 4.33112 6.47871 13.9255 1.99694C15.7006 1.16787 17.5713 0.519037 19.5844 0.0424233C20.5924 -0.16184 21.3246 0.388869 21.6623 1.32207C21.9481 2.11809 22.0457 2.99622 21.1443 3.40175ZM47.8178 3.40175C39.7245 5.65965 34.4562 10.3787 33.1473 18.5913C32.7907 20.8252 33.2887 19.138 34.7958 18.0045C39.7166 14.3028 49.3917 15.6135 50.7334 24.0673C53.4368 39.0356 34.8177 41.6269 29.3073 33.3603C28.0253 31.4388 27.1767 29.1959 26.8709 26.7328C25.5431 16.02 31.0047 6.47871 40.5991 1.99694C42.3741 1.16787 44.2438 0.519037 46.2579 0.0424233C47.266 -0.16184 47.9981 0.388869 48.3358 1.32207C48.6217 2.11809 48.7193 2.99622 47.8178 3.40175Z",
    fill: "#26CD9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIcon);
export default __webpack_public_path__ + "static/media/review-icon.ea58f0eb863278686ddee531af0d756b.svg";
export { ForwardRef as ReactComponent };